import type {ExtractPropsWithoutRef} from '@/types';

import {forwardRef} from 'react';

import {
  CollapsibleContent,
  CollapsibleContainer,
} from '@/components/Collapsible';

type Props = ExtractPropsWithoutRef<typeof CollapsibleContainer>;

export const CollapsibleSimple = forwardRef<
  React.ElementRef<typeof CollapsibleContainer>,
  Props
>(function CollapsibleSimpleComponent({children, ...props}, ref) {
  return (
    <CollapsibleContainer {...props} ref={ref}>
      <CollapsibleContent>{children}</CollapsibleContent>
    </CollapsibleContainer>
  );
});
